import React from 'react';
import { KeenIcon } from '@/components';
import FormInput from '@/components/ui/input/FormInput';

const Toolbar = ({ type = 'reference-data' }) => (
    <div className="flex items-center gap-2 mt-2 mb-4 justify-between">
        <div className='flex items-center gap-2'>
            <button className="flex items-center gap-1 px-2 py-2 bg-[#19c37d] text-white rounded text-sm hover:bg-[#16a86d] transition-colors">
                <KeenIcon icon="plus" /> Create {type === 'reference-data' ? 'Reference' : 'Suggest'}
            </button>
            <button className="flex items-center gap-1 px-2 py-2 bg-red-500 text-white rounded text-sm hover:bg-red-600 transition-colors">
                <KeenIcon icon="trash" /> Clear
            </button>
            <button className="flex items-center gap-1 px-2 py-2 bg-green-600 text-white rounded text-sm hover:bg-green-700 transition-colors">
                <KeenIcon icon="add-files" /> Import CSV
            </button>
            <div className="relative group ml-2">
                <KeenIcon icon="question" className="text-gray-400 text-xl" />
                <div className="absolute left-[60%] -translate-x-1/2 top-8 bg-gray-100 text-xs text-gray-700 rounded px-3 py-1 shadow hidden group-hover:block z-10">
                    CSV file must include headers: {type === 'reference-data' ? 'reference' : 'suggest'} <br />
                    <span className="italic text-gray-500">(Note: 100word)</span>
                </div>
            </div>
        </div>
        <div className='flex items-center justify-end'>
            <FormInput
                type="text"
                placeholder={`Filter ${type === 'reference-data' ? 'reference' : 'suggested'} by name`}
                icon={<KeenIcon icon="magnifier" className="text-gray-700" />}
                className="w-72"
            />
        </div>
    </div>
);

export { Toolbar }; 